import Box from "@mui/system/Box";
import styled from "styled-components";

export const Container = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
